// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {SurveyQuestion} from './SurveyQuestion';

const _associations = [
			{
				name: 'SurveyQuestions',
				model: new SurveyQuestion(),
				type: 'ArrayOfChildren',
				using: 'surveySectionId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Questions',
				groupTitle: '',
				displayOrder: 99,
				itemTitle: 'Survey Question',
				orderable: 'order',
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'surveySectionId',
				placeholder: null,
				key: 'surveySectionId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.surveySectionId,
				setter: (x, y) => x.surveySectionId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'surveyId',
				placeholder: null,
				key: 'surveyId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.surveyId,
				setter: (x, y) => x.surveyId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Section Name',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Code',
				placeholder: null,
				key: 'code',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.code,
				setter: (x, y) => x.code = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Description',
				placeholder: null,
				key: 'description',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.description,
				setter: (x, y) => x.description = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Info Title',
				placeholder: null,
				key: 'infoTitle',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'If set, an information icon will be displayed with this text.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 4,
				getter: (x) => x.infoTitle,
				setter: (x, y) => x.infoTitle = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Info Link',
				placeholder: null,
				key: 'infoLink',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'If set, the information icon will be a hyperlink to this URL.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.infoLink,
				setter: (x, y) => x.infoLink = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'order',
				placeholder: null,
				key: 'order',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.order,
				setter: (x, y) => x.order = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class SurveySection extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
